import { Quote } from "lucide-react";
import { FadeIn } from "./FadeIn";
import { TESTIMONIALS } from "@/lib/site";

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 sm:py-32 bg-brand-surface"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-16">
          <FadeIn>
            <p className="text-xs sm:text-sm uppercase tracking-[0.3em] text-brand-accent font-semibold mb-5">
              Loved by connoisseurs
            </p>
          </FadeIn>
          <FadeIn delay={0.1}>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-brand-primary leading-[1.05]">
              What our patrons <span className="italic">say.</span>
            </h2>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {TESTIMONIALS.map((q, i) => (
            <FadeIn key={q.name} delay={i * 0.1}>
              <figure
                data-testid={`testimonial-${i}`}
                className="h-full flex flex-col rounded-2xl border border-brand-borderColor bg-brand-base p-8 hover:-translate-y-1 transition-transform duration-500"
              >
                <Quote
                  size={28}
                  strokeWidth={1.5}
                  className="text-brand-accent"
                />
                <blockquote className="mt-5 font-display text-lg sm:text-xl text-brand-primary leading-relaxed flex-1">
                  "{q.text}"
                </blockquote>
                <figcaption className="mt-8 pt-5 border-t border-brand-borderColor">
                  <div className="font-medium text-brand-primary">
                    {q.name}
                  </div>
                  <div className="text-xs uppercase tracking-wider text-brand-textMuted mt-1">
                    {q.role}
                  </div>
                </figcaption>
              </figure>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
